//helper goes here for RandomImage
import main from "../../assets/images/me2.jpg"
import grad from "../../assets/images/grad.jpg"
import waterGaden from "../../assets/images/watergarden.jpg"
import catfish from "../../assets/images/Catfish0.jpg"

export type RandomImageProps = {}
const imgs = [
    { content: grad, alt: "UT graduation 2020" },
    { content: waterGaden, alt: "Fort Worth Water Garden" },
    { content: catfish, alt: "First catch of 2026" },
    { content: main, alt: "profile" },
]
export const images = imgs.map(i => i.content)
export const alt = imgs.map(i => i.alt)


export const IMG_SIZE = 500
export { }
